import BaseModelAPI from '../BaseModelAPI';

export default class RackList extends BaseModelAPI {

	static entity = 'racklist'
	static entityName = 'rack';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
